import { CloneFavoriteDialogComponent } from './clone-favorite-dialog.component';
import { NgModule } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule } from '@angular/material/dialog';
import { MatInputModule } from '@angular/material/input';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';

@NgModule({
    declarations: [CloneFavoriteDialogComponent],
  imports: [
      CommonModule,
      MatButtonModule,
      MatDialogModule,
      MatInputModule,
      FormsModule,
      MatSelectModule
    ],
    exports: [
        CloneFavoriteDialogComponent
    ]
})
export class CloneFavoriteDialogModule { }
